export default "__VITE_ASSET__C$cJSMKz__"